/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon20Regular = forwardRef('TextBulletIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4 6.25A1.251 1.251 0 1 0 4 3.75a1.251 1.251 0 0 0 0 2.502Z" }),
        React.createElement("path", { d: "M7 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 7 5Z" }),
        React.createElement("path", { d: "M7.75 9.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" }),
        React.createElement("path", { d: "M7.75 14.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" }),
        React.createElement("path", { d: "M4 16.255a1.25 1.25 0 1 0 0-2.502 1.25 1.25 0 0 0 0 2.502Z" }),
        React.createElement("path", { d: "M5.25 10.002a1.251 1.251 0 1 1-2.501 0 1.251 1.251 0 0 1 2.502 0Z" })));
});
